import type { FaireProductEntity } from "../../entity_types/product";

export const p_c1qa5xu0gx: FaireProductEntity = {
  token: "p_c1qa5xu0gx",
  type: "product",
  name: "1 oz Fire Fighter Inflammation Herbal Tincture",
  brandToken: "b_8i6qzemm69",
  brandName: "Roots To Remedies",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c321f9603d2417e95421e398e23583e95253a290d49d4d0b7b77a1fcd59ee19e/1554201375.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c99660d35eeae57a6eb562df8bf8f9aa3ee1191c4a40495734be0483a600a44.png",
  ],
  priceDollars: 11,
  description:
    '"Fire fighter" inflammation reducing herbal tincture. Not only does inflammation cause pain, it can be linked to even more serious conditions like cancer, auto-immune and immune issues, mental issues, allergies. Reducing the inflammation in the body is key for proper health.',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:26.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
